/**
 * McpConnectResult — wertet `?mcp=connected|error` nach dem Orakel-Login aus (PV-046).
 *
 * Die API springt nach dem Login an die Seite zurück, von der aus er gestartet wurde,
 * und hängt das Ergebnis als Query-Param an. Deshalb hängt dieser Auswerter in der
 * App-Shell und nicht mehr nur auf der Einstellungsseite: Meldung zeigen, MCP-Status
 * neu laden, Param entfernen — alle übrigen Parameter der Seite bleiben stehen.
 */
import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { useToast } from '../toast.js';

export function McpConnectResult() {
  const [searchParams, setSearchParams] = useSearchParams();
  const queryClient = useQueryClient();
  const toast = useToast();
  const { i18n } = useTranslation();

  useEffect(() => {
    const mcpParam = searchParams.get('mcp');
    if (!mcpParam) return;
    if (mcpParam === 'connected') {
      toast.success(i18n.t('v2.settings.mcp_connected_toast', 'MCP-Verbindung hergestellt'));
      void queryClient.invalidateQueries({ queryKey: ['mcp-status'] });
    } else if (mcpParam === 'error') {
      toast.error(i18n.t('v2.settings.mcp_connect_error_toast', 'MCP-Verbindung fehlgeschlagen'));
    }
    const next = new URLSearchParams(searchParams);
    next.delete('mcp');
    setSearchParams(next, { replace: true });
  }, [searchParams, toast, i18n, queryClient, setSearchParams]);

  return null;
}
